import {
  SearchFiltersActions,
  SearchFiltersActionTypes
} from '../../../../../reducers/search-filters/actions';
import { updateQuery } from '../../../../../helpers/common';
import { useRouter } from 'next/router';
import {
  SearchFiltersInterface,
  SearchFiltersTypes
} from '../../../../../reducers/search-filters/reducer';
import SortByPresentation from './SortByPresentation';
import MobileSortByPresentation from './Mobile/MobileSortByPresention';
import { useSelector } from 'react-redux';
import { InputOption } from '../../../../../new-lib/types/search-filters';
import { logEvent } from '../../../../../new-lib/analytics';
import { Dispatch, SetStateAction } from 'react';

export type SelectedSort = {
  order: string;
  direction: string;
};

interface SortByContainerProps {
  sortByOptions: InputOption[];
  searchFiltersState: SearchFiltersInterface;
  searchFiltersDispatch: React.Dispatch<SearchFiltersActions>;
  sortLocation: string;
  isMobileCloseModal?: () => void;
  setStackSort?: Dispatch<SetStateAction<boolean>>;
}
const SortByContainer = ({
  sortByOptions,
  searchFiltersState,
  searchFiltersDispatch,
  sortLocation,
  isMobileCloseModal,
  setStackSort
}: SortByContainerProps) => {
  const router = useRouter();
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const onChange = (selectedSort: SelectedSort) => {
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_SORTING_ORDER,
      payload: {
        order_by: selectedSort.order,
        order_direction: selectedSort.direction
      }
    });
    const valueQuary = [selectedSort.order, selectedSort.direction];
    logEvent.search(`filter_sort`, sortLocation, 'filter', searchFiltersState, {
      [SearchFiltersTypes.SORT_BY]: valueQuary.toString()
    });
    if (selectedSort.order === '') {
      updateQuery(router, undefined, [SearchFiltersTypes.SORT_BY]);
    } else {
      updateQuery(
        router,
        [
          { name: SearchFiltersTypes.SORT_BY, value: valueQuary.toString() },
          { name: 'page_number', value: 1 }
        ],
        undefined
      );
    }
    if (isMobileCloseModal) {
      isMobileCloseModal();
    }
  };

  return (
    <>
      {!isMobile && (
        <SortByPresentation
          options={sortByOptions}
          onChange={onChange}
          selectedValues={
            searchFiltersState.searchFilters[SearchFiltersTypes.SORT_BY]
          }
          setStackSort={setStackSort}
          isNawyNow={sortLocation === 'nawy_now'}
        />
      )}
      {isMobile && (
        <MobileSortByPresentation
          options={sortByOptions}
          onChange={onChange}
          selectedValues={
            searchFiltersState.searchFilters[SearchFiltersTypes.SORT_BY]
          }
          // isNawyNow={sortLocation === 'nawy-now'}
        />
      )}
    </>
  );
};

export default SortByContainer;
